import React, { useContext, useState } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Box, Button, Grid, Typography } from '@mui/material'
import { OnboardingTile } from 'components/OnboardingTile'

export function TopPriorities({ onNext, key }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const questionArray = [
    {
      id: 'livingComfortably',
      optionLabel: 'Living Comfortably',
    },
    {
      id: 'growth',
      optionLabel: 'Growing my funds as much as possible',
    },
    {
      id: 'legacy',
      optionLabel: 'Leaving as much behind for my beneficiaries',
    },
  ]

  const initialOptions = questionArray.reduce((acc, item) => {
    acc[item.id] =
      intakeState?.riskAssessment?.topPriorities?.[item.id] || false
    return acc
  }, {})

  const [options, setOptions] = useState(initialOptions)

  const toggleOption = (id) => {
    const isCurrentlySelected = options[id]
    const selectedCount = Object.values(options).filter(Boolean).length

    // If trying to select a new option and already have 2 selected, don't allow it
    if (!isCurrentlySelected && selectedCount >= 2) {
      return
    }

    const topPriorities = { ...options, [id]: !options[id] }
    setOptions(topPriorities)

    updateIntakeStateAtKey({
      riskAssessment: {
        ...intakeState?.riskAssessment,
        topPriorities: { ...topPriorities },
      },
    })
  }

  const handleContinue = () => {
    if (onNext) onNext()
  }

  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          What are your top priorities in retirement?
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{ lineHeight: '1.2' }}
        fontSize={{ xs: '16px', sm: '20px' }}
      >
        Select two of the following: (
        {Object.values(options).filter(Boolean).length}/2 selected)
      </Typography>
      <Box my={4} mb={1}>
        <Grid container spacing={1} justifyContent="center" mb={0}>
          {questionArray.map((question) => {
            const isSelected = options[question.id]
            const selectedCount = Object.values(options).filter(Boolean).length
            const isDisabled = !isSelected && selectedCount >= 2

            return (
              <Grid item xs={12} sm={6} md={4} key={question.optionLabel}>
                <OnboardingTile
                  label={question.optionLabel}
                  active={isSelected}
                  onClick={
                    isDisabled ? undefined : () => toggleOption(question.id)
                  }
                  disabled={isDisabled}
                ></OnboardingTile>
              </Grid>
            )
          })}
        </Grid>
      </Box>

      <Box mt={3} display="flex" gap={2} justifyContent="flex-end">
        <Button 
          variant="parcoRounded" 
          onClick={handleContinue} 
          disabled={Object.values(options).filter(Boolean).length !== 2}
        >
          Next
        </Button>
      </Box>
    </Grid>
  )
}

export default TopPriorities
